<template>
  <div>
    <TagSelector mainHeading="" optionName="users" availableOptionsHeading="All Volunteers"
      selectedOptionsHeading="Administrators for this workgroup" :initial-skills="availableAllUsers" :showDefaultMessage="false"
      v-model:interests="currentPreferedUsers" :onSave="handleSaveActivities" :loading="loading" :isSaving="submitting" />
  </div>
</template>

<script setup>
import { onMounted, ref, computed } from "vue";
import { useStore } from "vuex";
import TagSelector from "@/components/common/TagSelector.vue";
import { useRoute } from "vue-router";
import { useToast } from "vue-toast-notification";

const store = useStore();
const route = useRoute();
const toast = useToast();
const loading = ref(false);
const submitting = ref(false);

// ✅ Get IDs from route params
const workgroupId = Number(route.params.workgroupid);

// ✅ Reactive state
const availableAllUsers = ref([]); // all available users
const currentPreferedUsers = ref([]); // current workgroup admins

const workgroupAdmins = computed(() => store.getters.workgroupAdmins);

// ✅ Load workgroup admins
const loadWorkgroupAdmins = async () => {
  try {
    await store.dispatch("fetchWorkgroupAdmins", workgroupId);

    // Map data for TagSelector
    availableAllUsers.value = workgroupAdmins.value.available.map((v) => ({
      id: v.personid,
      name: `${v.firstname} ${v.lastname}`,
      description: v.email || "",
    }));

    currentPreferedUsers.value = workgroupAdmins.value.admins.map((v) => ({
      id: v.personid,
      name: `${v.firstname} ${v.lastname}`,
      description: v.email || "",
    }));
  } catch (error) {
    console.error("Failed to load workgroup admins:", error);
  }
};

// ✅ Save handler for workgroup admins
const handleSaveActivities = async (selected) => {
  submitting.value = true;
  try {
    const personIds = selected.map((x) => x.id);

    const result = await store.dispatch("saveWorkgroupAdmins", {
      workgroupId,
      personIds,
    });

    if (result.success) {
      toast.success('Workgroup administrators saved successfully!', { position: 'top-right' });
      await loadWorkgroupAdmins(); // Re-fetch to update the list
    }
  } catch (error) {
    console.error("Failed to save workgroup administrators:", error);
    toast.error(`Failed to save workgroup administrators: ${error.message}`, { position: 'top-right' });
  } finally {
    submitting.value = false;
  }
};

onMounted(async () => {
  loading.value = true;
  try {
    await loadWorkgroupAdmins();
  } finally {
    loading.value = false;
  }
});
</script>